const sorting = {
  en: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 19, 20, 21, 22, 23, 25, 26, 29, 142, 27, 30, 31, 32, 33, 206, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 131, 45, 87, 88, 89, 90, 207, 189, 46, 47, 96, 97, 98, 99, 48, 54, 102, 103, 208, 190, 49, 52, 50, 51, 53, 18, 55, 24, 56, 57, 28, 58, 59, 60, 61, 62, 63, 64, 66, 65, 68, 69, 70, 71, 72, 73, 197, 79, 74, 75, 77, 76, 78, 80, 81, 82, 83, 85, 91, 93, 95, 100, 101, 211, 104, 94, 105, 107, 108, 106, 109, 110, 111, 112, 113, 124, 114, 115, 116, 117, 118, 119, 121, 122, 123, 125, 126, 127, 128, 129, 185, 120, 130, 132, 133, 134, 137, 135, 136, 138, 139, 140, 141, 143, 144, 212, 145, 146, 147, 148, 149, 150, 151, 92, 153, 154, 152, 174, 175, 158, 159, 160, 161, 164, 86, 165, 166, 168, 169, 170, 156, 171, 177, 172, 173, 176, 178, 210, 179, 180, 162, 163, 181, 155, 182, 183, 184, 209, 186, 187, 188, 191, 192, 193, 194, 195, 196, 203, 67, 204, 198, 199, 200, 201, 202, 205, 84, 157, 167, 1000],
  de: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 55, 54, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 211, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 185, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 209, 143, 212, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 156, 157, 158, 159, 160, 161, 162, 163, 164, 86, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 210, 179, 180, 181, 182, 155, 183, 184, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 204, 199, 200, 201, 202, 203, 205, 206, 207, 208, 1000]
}

const labels = {
  en: {
    1: 'Hamburg',
    2: 'Schleswig-Holstein',
    3: 'Mecklenburg-West Pomerania',
    4: 'Berlin',
    5: 'Brandenburg',
    6: 'Lower Saxony',
    7: 'Bremen',
    8: 'North Rhine Westphalia',
    9: 'Hesse',
    10: 'Saxony',
    11: 'Saxony-Anhalt',
    12: 'Thuringia',
    13: 'Rhineland-Palatinate',
    14: 'Saarland',
    15: 'Baden-Wurttemberg',
    16: 'Bavaria',
    17: 'Afghanistan',
    19: 'Albania',
    20: 'Algeria',
    21: 'Andorra',
    22: 'Angola',
    23: 'Antigua and Barbuda',
    25: 'Argentina',
    26: 'Armenia',
    29: 'Australia',
    142: 'Austria',
    27: 'Azerbaijan',
    30: 'Bahamas',
    31: 'Bahrain',
    32: 'Bangladesh',
    33: 'Barbados',
    206: 'Belarus',
    34: 'Belgium',
    35: 'Belize',
    36: 'Benin',
    37: 'Bhutan',
    38: 'Bolivia',
    39: 'Bosnia-Herzegovina',
    40: 'Botswana',
    41: 'Brazil',
    42: 'Brunei',
    43: 'Bulgaria',
    44: 'Burkina Faso',
    131: 'Burma / Myanmar',
    45: 'Burundi',
    87: 'Cambodia',
    88: 'Cameroon',
    89: 'Canada',
    90: 'Cape Verde',
    207: 'Central African Rep.',
    189: 'Chad',
    46: 'Chile',
    47: 'China',
    96: 'Colombia',
    97: 'Comoros',
    98: 'Congo',
    99: 'Congo',
    48: 'Costa Rica',
    54: 'Cote d\'Ivoire',
    102: 'Croatia',
    103: 'Cuba',
    208: 'Cyprus',
    190: 'Czechia',
    49: 'Denmark',
    52: 'Djibouti',
    50: 'Dominica',
    51: 'Dominican Republic',
    53: 'Ecuador',
    18: 'Egypt',
    55: 'El Salvador',
    24: 'Equatorial Guinea',
    56: 'Eritrea',
    57: 'Estonia',
    28: 'Ethiopia',
    58: 'Fiji',
    59: 'Finland',
    60: 'France',
    61: 'Gabon',
    62: 'Gambia',
    63: 'Georgia',
    64: 'Ghana',
    66: 'Greece',
    65: 'Grenada',
    68: 'Guatemala',
    69: 'Guinea',
    70: 'Guinea-Bissau',
    71: 'Guyana',
    72: 'Haiti',
    73: 'Honduras',
    197: 'Hungary',
    79: 'Iceland',
    74: 'India',
    75: 'Indonesia',
    77: 'Iran',
    76: 'Iraq',
    78: 'Ireland',
    80: 'Israel',
    81: 'Italy',
    82: 'Jamaica',
    83: 'Japan',
    85: 'Jordan',
    91: 'Kazakhstan',
    93: 'Kenya',
    95: 'Kiribati',
    100: 'Korea (North)',
    101: 'Korea (South)',
    211: 'Kosovo',
    104: 'Kuwait',
    94: 'Kyrgyzstan',
    105: 'Laos',
    107: 'Latvia',
    108: 'Lebanon',
    106: 'Lesotho',
    109: 'Liberia',
    110: 'Libya',
    111: 'Liechtenstein',
    112: 'Lithuania',
    113: 'Luxembourg',
    124: 'Macedonia',
    114: 'Madagascar',
    115: 'Malawi',
    116: 'Malaysia',
    117: 'Maldives',
    118: 'Mali',
    119: 'Malta',
    121: 'Marshall Islands',
    122: 'Mauritania',
    123: 'Mauritius',
    125: 'Mexico',
    126: 'Micronesia',
    127: 'Moldova',
    128: 'Monaco',
    129: 'Mongolia',
    185: 'Montenegro',
    120: 'Morocco',
    130: 'Mozambique',
    132: 'Namibia',
    133: 'Nauru',
    134: 'Nepal',
    137: 'Netherlands',
    135: 'New Zealand',
    136: 'Nicaragua',
    138: 'Niger',
    139: 'Nigeria',
    140: 'Norway',
    141: 'Oman',
    143: 'Pakistan',
    144: 'Palau',
    212: 'Palestine',
    145: 'Panama',
    146: 'Papua New Guinea',
    147: 'Paraguay',
    148: 'Peru',
    149: 'Philippines',
    150: 'Poland',
    151: 'Portugal',
    92: 'Qatar',
    153: 'Romania',
    154: 'Russia',
    152: 'Rwanda',
    174: 'Saint Kitts and Nevis',
    175: 'Saint Lucia',
    158: 'Samoa',
    159: 'San Marino',
    160: 'Sao Tomé und Príncipe',
    161: 'Saudi Arabia',
    164: 'Senegal',
    86: 'Serbia',
    165: 'Seychelles',
    166: 'Sierra Leone',
    168: 'Singapore',
    169: 'Slovakia',
    170: 'Slovenia',
    156: 'Solomon Islands',
    171: 'Somalia',
    177: 'South Africa',
    172: 'Spain',
    173: 'Sri Lanka',
    176: 'St. Vincent + Grenadines',
    178: 'Sudan',
    210: 'Sudan',
    179: 'Suriname',
    180: 'Swaziland',
    162: 'Sweden',
    163: 'Switzerland',
    181: 'Syria',
    155: 'Taiwan',
    182: 'Tajikistan',
    183: 'Tanzania',
    184: 'Thailand',
    209: 'Timor-Leste / Osttimor',
    186: 'Togo',
    187: 'Tonga',
    188: 'Trinidad and Tobago',
    191: 'Tunisia',
    192: 'Turkey',
    193: 'Turkmenistan',
    194: 'Tuvalu',
    195: 'Uganda',
    196: 'Ukraine',
    203: 'United Arab Emirates',
    67: 'United Kingdom',
    204: 'United States',
    198: 'Uruguay',
    199: 'Uzbekistan',
    200: 'Vanuatu',
    201: 'Vatican City',
    202: 'Venezuela',
    205: 'Vietnam',
    84: 'Yemen',
    157: 'Zambia',
    167: 'Zimbabwe',
    1000: 'not specified'
  },
  de: {
    1: 'Hamburg',
    2: 'Schleswig-Holstein',
    3: 'Mecklenburg-Vorpommern',
    4: 'Berlin',
    5: 'Brandenburg',
    6: 'Niedersachsen',
    7: 'Bremen',
    8: 'Nordrhein-Westfalen',
    9: 'Hessen',
    10: 'Sachsen',
    11: 'Sachsen-Anhalt',
    12: 'Thüringen',
    13: 'Rheinland-Pfalz',
    14: 'Saarland',
    15: 'Baden-Württemberg',
    16: 'Bayern',
    17: 'Afghanistan',
    18: 'Ägypten',
    19: 'Albanien',
    20: 'Algerien',
    21: 'Andorra',
    22: 'Angola',
    23: 'Antigua und Barbuda',
    24: 'Äquatorialguinea',
    25: 'Argentinien',
    26: 'Armenien',
    27: 'Aserbaidschan',
    28: 'Äthiopien',
    29: 'Australien',
    30: 'Bahamas',
    31: 'Bahrein',
    32: 'Bangladesch',
    33: 'Barbados',
    34: 'Belgien',
    35: 'Belize',
    36: 'Benin',
    37: 'Bhutan',
    38: 'Bolivien',
    39: 'Bosnien-Herzegowina',
    40: 'Botsuana',
    41: 'Brasilien',
    42: 'Brunei',
    43: 'Bulgarien',
    44: 'Burkina Faso',
    45: 'Burundi',
    46: 'Chile',
    47: 'China',
    48: 'Costa Rica',
    49: 'Dänemark',
    50: 'Dominica',
    51: 'Dominikanische Rep.',
    52: 'Dschibuti',
    53: 'Ecuador',
    55: 'El Salvador',
    54: 'Elfenbeinküste',
    56: 'Eritrea',
    57: 'Estland',
    58: 'Fidschi',
    59: 'Finnland',
    60: 'Frankreich',
    61: 'Gabun',
    62: 'Gambia',
    63: 'Georgien',
    64: 'Ghana',
    65: 'Grenada',
    66: 'Griechenland',
    67: 'Großbritannien',
    68: 'Guatemala',
    69: 'Guinea',
    70: 'Guinea-Bissau',
    71: 'Guyana',
    72: 'Haiti',
    73: 'Honduras',
    74: 'Indien',
    75: 'Indonesien',
    76: 'Irak',
    77: 'Iran',
    78: 'Irland',
    79: 'Island',
    80: 'Israel',
    81: 'Italien',
    82: 'Jamaika',
    83: 'Japan',
    84: 'Jemen',
    85: 'Jordanien',
    87: 'Kambodscha',
    88: 'Kamerun',
    89: 'Kanada',
    90: 'Kap Verde',
    91: 'Kasachstan',
    92: 'Katar',
    93: 'Kenia',
    94: 'Kirgisistan',
    95: 'Kiribati',
    96: 'Kolumbien',
    97: 'Komoren',
    98: 'Kongo',
    99: 'Kongo',
    100: 'Korea (NORD ! )',
    101: 'Korea (Südkorea)',
    211: 'Kosovo',
    102: 'Kroatien',
    103: 'Kuba',
    104: 'Kuwait',
    105: 'Laos',
    106: 'Lesotho',
    107: 'Lettland',
    108: 'Libanon',
    109: 'Liberia',
    110: 'Libyen',
    111: 'Liechtenstein',
    112: 'Litauen',
    113: 'Luxemburg',
    114: 'Madagaskar',
    115: 'Malawi',
    116: 'Malaysia',
    117: 'Malediven',
    118: 'Mali',
    119: 'Malta',
    120: 'Marokko',
    121: 'Marshallinseln',
    122: 'Mauretanien',
    123: 'Mauritius',
    124: 'Mazedonien',
    125: 'Mexiko',
    126: 'Mikronesien',
    127: 'Moldawien / Rep. Moldau',
    128: 'Monaco',
    129: 'Mongolei',
    185: 'Montenegro',
    130: 'Mosambik',
    131: 'Myanmar (Burma)',
    132: 'Namibia',
    133: 'Nauru',
    134: 'Nepal',
    135: 'Neuseeland',
    136: 'Nicaragua',
    137: 'Niederlande',
    138: 'Niger',
    139: 'Nigeria',
    140: 'Norwegen',
    141: 'Oman',
    142: 'Österreich',
    209: 'Osttimor / Timor-Leste',
    143: 'Pakistan',
    212: 'Palästina',
    144: 'Palau / Belau',
    145: 'Panama',
    146: 'Papua-Neuguinea',
    147: 'Paraguay',
    148: 'Peru',
    149: 'Philippinen',
    150: 'Polen',
    151: 'Portugal',
    152: 'Ruanda',
    153: 'Rumänien',
    154: 'Russland',
    156: 'Salomonen',
    157: 'Sambia',
    158: 'Samoa',
    159: 'San Marino',
    160: 'Sao Tomé und Príncipe',
    161: 'Saudi-Arabien',
    162: 'Schweden',
    163: 'Schweiz',
    164: 'Senegal',
    86: 'Serbien',
    165: 'Seychellen',
    166: 'Sierra Leone',
    167: 'Simbabwe',
    168: 'Singapur',
    169: 'Slowakei',
    170: 'Slowenien',
    171: 'Somalia',
    172: 'Spanien',
    173: 'Sri Lanka',
    174: 'St. Kitts u. Nevis',
    175: 'St. Lucia',
    176: 'St. Vincent u. Grenadinen',
    177: 'Südafrika',
    178: 'Sudan',
    210: 'Sudan',
    179: 'Suriname',
    180: 'Swasiland',
    181: 'Syrien',
    182: 'Tadschikistan',
    155: 'Taiwan',
    183: 'Tansania',
    184: 'Thailand',
    186: 'Togo',
    187: 'Tonga',
    188: 'Trinidad u. Tobago',
    189: 'Tschad',
    190: 'Tschechien',
    191: 'Tunesien',
    192: 'Türkei',
    193: 'Turkmenistan',
    194: 'Tuvalu',
    195: 'Uganda',
    196: 'Ukraine',
    197: 'Ungarn',
    198: 'Uruguay',
    204: 'USA',
    199: 'Usbekistan',
    200: 'Vanuatu',
    201: 'Vatikanstadt',
    202: 'Venezuela',
    203: 'Ver. Arabische Emirate',
    205: 'Vietnam',
    206: 'Weißrussland',
    207: 'Zentralafrikanische Rep.',
    208: 'Zypern',
    1000: 'Keine Angaben'
  }
}

/**
 * Get order for country names
 * @param {'en'|'de'} language Language code
 * @returns {number[]} Country name sorting
 */
export function countrySorting (language) {
  return sorting[language]
}

/**
 * Get country labels
 * @param {'en'|'de'} language Language code
 * @returns {Object<number, string>} Country labels
 */
export function countryLabels (language) {
  return labels[language]
}
